<template>
  <div class="search">
    <search-ean v-on:search="search" v-bind:loading="loading"></search-ean>
    <h2 class="center-align">OU</h2>
    <search-name v-on:search="search" v-bind:loading="loading"></search-name>
    <p v-if="error" class="center-align red-text">Erreur lors de la recherche. Veuillez réessayer.</p>
    <product-proposal v-if="proposal" v-bind:products="proposal"></product-proposal>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import SearchEan from "@/components/Search/SearchEan.vue";
import SearchName from "@/components/Search/SearchName.vue";
import ProductProposal from "@/components/Search/ProductProposal.vue";

export default {
  data() {
    return {
      loading: null,
      proposal: null,
      error: null
    };
  },

  methods: {
    search: function(ean = null, name = null) {
      var vm = this;
      this.error = false;
      this.loading = true;
      this.proposal = null;

      axios
        .get(process.env.VUE_APP_ERP_URL + "/products/search", {
          params: {
            // Permet d'envoyer uniquement le paramètre renseigné. Recherche des produits par fin d'EAN ou par nom
            ean: ean !== null ? '%' + ean : '',
            name: name !== null ? name : '',
            limit: 5
          }
        })
        .then(function(response) {
          vm.loading = false;
          // Si aucun produit n'est trouvé, affiche une fenêtre sweet alert
          if (response.data.length == 0) {
            swal({
              text: "Aucun produit ne correspond à votre recherche",
              icon: "error"
            });
          }
          // Si 1 seul produit correspond à la recherhce, redirige sur la fiche du produit
          else if (response.data.length == 1) {
            vm.$router.push({
              name: "product-view",
              params: { id: response.data[0].id }
            });
          }
          // Si plusieurs produit correspondent à la recherche, récupère les résultats pour faire des propositions
          else {
            vm.proposal = response.data;
          }
        })
        .catch(function(error) {
          vm.error = true;
          vm.loading = false;
        });
    }
  },
  components: {
    SearchEan,
    SearchName,
    ProductProposal
  }
};
</script>

<style>
.search {
  padding: 1em 1em 0 1em;
  background-color: #eeeeee;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  margin-bottom: 1.5em;
}
</style>
